<template>
    <div class="c-signature" ref="container">
        <canvas ref="canvas" width="300" height="300"></canvas>

        <div class="c-signature__clear">
            <button class="c-btn c-btn--secondary c-btn--tiny" type="button" @click="clear">
                <svg width="16" height="16" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><defs><path d="M9 11c.55 0 1 .45 1 1v4c0 .55-.45 1-1 1s-1-.45-1-1v-4c0-.55.45-1 1-1Zm6 0c.55 0 1 .45 1 1v4c0 .55-.45 1-1 1s-1-.45-1-1v-4c0-.55.45-1 1-1Zm3 8c0 .551-.448 1-1 1H7c-.552 0-1-.449-1-1V8h12v11ZM10 4.328c0-.155.214-.328.5-.328h3c.286 0 .5.173.5.328V6h-4V4.328ZM21 6h-5V4.328C16 3.044 14.879 2 13.5 2h-3C9.121 2 8 3.044 8 4.328V6H3c-.55 0-1 .45-1 1s.45 1 1 1h1v11c0 1.654 1.346 3 3 3h10c1.654 0 3-1.346 3-3V8h1c.55 0 1-.45 1-1s-.45-1-1-1Z" id="trash"/></defs><use fill="currentColor" fill-rule="nonzero" xlink:href="#trash"/></svg>
            </button>
        </div>
    </div>

</template>


<script>
import SignaturePad from 'signature_pad';

export default {
    props: {
        height: {
            type: Number,
            default: 320
        }
    },
    data() {
        return {
            pad: null,
            signatureWidth: null
        }
    },
    methods: {
        clear() {
            this.pad.clear();
        },

        signature() {
            return this.pad.toDataURL();
        }
        // calculateSignatureWidth() {
        //     this.signatureWidth = this.$refs.container.scrollWidth;
        // }
    },
    mounted() {
        this.$nextTick( () => {
            this.pad = new SignaturePad(this.$refs.canvas);
        });
    },
    // created() {
    //     window.addEventListener("resize", this.calculateSignatureWidth);
    // }
}
</script>
